import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBiwbC0ngwTxb7nC56M7ybuBNZxf99tdzI",
  authDomain: "bsi-muskyhuntertv.firebaseapp.com",
  projectId: "bsi-muskyhuntertv",
  storageBucket: "bsi-muskyhuntertv.appspot.com",
  messagingSenderId: "441993674423",
  appId: "1:441993674423:web:c5b12651cb21b6eb775732",
  measurementId: "G-NYHRC4XV4G",
  databaseURL: "https://bsi-muskyhuntertv.firebaseio.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
